import React from 'react'
import { ButtonPrimary } from '../Button'
import { CHAINS, CURRENT_CHAIN } from '@hyperswap/addresses'

const SwitchNetworkButton: React.FC = () => {
  const switchNetwork = async (chainId: keyof typeof CHAINS) => {
    const network = CHAINS[chainId]

    if (!network) return
    try {
      // @ts-ignore
      await window.ethereum.request({
        method: 'wallet_requestPermissions',
        params: [{ eth_accounts: {} }],
      })

      // @ts-ignore
      await window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: network.chainId }],
      })
    } catch (switchError) {
      // This error code indicates that the chain has not been added to MetaMask
      // @ts-ignore
      if (switchError?.code === 4902 || switchError?.code === -32603) {
        try {
          // @ts-ignore
          await window.ethereum.request({
            method: 'wallet_addEthereumChain',
            params: [network],
          })

          // @ts-ignore
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: network.chainId }],
          })
        } catch (addError) {
          console.error('Failed to add the network:', addError)
        }
      } else {
        console.error('Failed to switch the network:', switchError)
      }
    }
  }

  return (
    <ButtonPrimary marginTop={3} onClick={() => switchNetwork(CURRENT_CHAIN)}>
      Switch to HyperEVM
    </ButtonPrimary>
  )
}

export default SwitchNetworkButton
